import React from "react";
import { exact, number, string } from "prop-types";
import styles from "./RegionSchoolsAttendanceRow.module.styl";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { percentageLevels } from "utils/indicator/indicatorSettings.js";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";

export default function RegionSchoolsAttendanceRow({ schoolAttendance, regionId }) {
    const indicatorStyle = percentageLevels.indicatorColor(schoolAttendance.attendancePercent);
    const options = chartOptions(indicatorStyle);
    const series = [schoolAttendance.attendancePercent];

    return (
        <div className={styles.row}>
            <Link
                to={`/attendance/region/${regionId}/school/${schoolAttendance.schoolId}`}
                className={styles.schoolName}
            >
                {schoolAttendance.schoolName}
            </Link>
            <div className={styles.municipalityName}>{schoolAttendance.municipalityName}</div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

RegionSchoolsAttendanceRow.propTypes = {
    regionId: number.isRequired,
    schoolAttendance: exact({
        schoolId: number.isRequired,
        schoolName: string.isRequired,
        municipalityName: string,
        attendancePercent: number.isRequired,
    }),
};
